<elcia-multi-dropdown [control]="control()"
                      [items]="items()"
                      [label]="'invoice.status'"
                      [textField]="'name'"/>
